import "../../../shared/data/configuration/state/index2.js";
import "@ado/base-service";
import "@ado/location-library";
import "@ado/cookie-library";
import "../../../shared/data/csr/state/index2.js";
import { setShowIpRedirectPrompt as w } from "../../../shared/data/layout/state/index.js";
import "../../../shared/data/location/state/index.js";
import "../../../shared/data/navigation/state/index2.js";
import "@ado/experiment-library";
import "../../../search/state/index2.js";
import "../../../shared/data/user/state/index2.js";
import "@ado/acs-standard-library";
import { defineComponent as z, ref as l, onUpdated as A, onBeforeMount as b } from "vue";
import { useBaseApplicationTranslation as g } from "../../../shared/libraries/local-translations/index.js";
import { submitInternalEventAndRedirectToPage as x } from "../../../shared/data/tracking/utilities/index.js";
import { TRACKING_EVENTS as E } from "../../../shared/data/tracking/types/index.js";
import { submitInternalEvent as B } from "@ado/tracking-library";
import { getJSONObjectFromCookie as c } from "../../../shared/libraries/cookie-handling/index.js";
import D from "./index3.js";
import { getDefaultCookie as m, setRedirectCountryInCookie as M, setRedirectUrlInCookie as O, setShowPromptInCookie as v } from "../utilities/index.js";
const ae = z({
  name: "RedirectPrompt",
  components: {
    BasePrompt: D
  },
  props: {
    currentCountryName: {
      type: String,
      required: !0,
      default: "United States"
    },
    currentCountryCode: {
      type: String,
      required: !0,
      default: "US"
    }
  },
  beforeUnmount() {
    this.handleWindowResize(), window.removeEventListener("click", this.outsidePromptClick), window.removeEventListener("resize", this.handleWindowResize);
  },
  mounted() {
    window.addEventListener("click", this.outsidePromptClick), window.addEventListener("resize", this.handleWindowResize), this.handleWindowResize();
  },
  setup(R) {
    const i = "ShowIpRedirectPrompt", s = "ip-redirect-prompt", n = l(!1), a = l(!1), d = l(0), y = 80, P = 28, I = g(), { t: k } = g(), S = I.isLoaded, N = (e) => {
      const t = document.getElementById(s);
      if (t != null) {
        let o = 0;
        navigator.userAgent.indexOf("Firefox") > -1 && (o = 20), t.style.right = e > 0 ? e - y + o + "px" : "0px";
      }
    }, _ = (e) => {
      e.style.right = "0px", d.value = 0, a.value = !0;
    }, u = () => {
      if (n.value === !0)
        if (window.innerWidth < 990) {
          if (a.value === !1) {
            const e = document.getElementById(s);
            e && _(e);
          }
        } else {
          a.value = !1;
          const e = document.getElementById("header");
          if (e) {
            const t = e.querySelector(".country-nav-link");
            if (t) {
              const o = t.getBoundingClientRect();
              if (d.value !== Math.round(window.innerWidth - o.x)) {
                d.value = Math.round(window.innerWidth - o.x);
                const r = window.innerWidth - o.x - P / 2;
                N(r);
              }
            }
          }
        }
    };
    A(() => {
      u();
    }), b(() => {
      const e = c(
        i,
        m()
      );
      if (n.value = !1, e.ShowPrompt === !0) {
        const t = String(R.currentCountryName) !== String(e.RedirectToCountryName);
        n.value = t;
      }
      w(n.value);
    });
    const p = () => {
      v(i, !1);
      const e = {
        ...E.HEADER_IP_REDIRECT_PROMPT_DONT_CHANGE_CLICK
      };
      B(e);
    }, T = () => {
      v(i, !1);
      const e = {
        ...E.HEADER_IP_REDIRECT_PROMPT_CHANGE_COUNTRY_CLICK
      };
      x(e, {
        url: c(i, m()).RedirectToUrl
      });
    }, f = () => {
      n.value = !1, w(n.value);
    }, L = (e) => {
      T(), f(), e.stopPropagation();
    }, C = () => {
      f(), p();
    }, h = (e) => {
      const t = document.getElementById(s);
      if (t !== null) {
        const o = t === e.target;
        let r = !1;
        o || t.querySelectorAll("*").forEach((W) => {
          r = r || W === e.target;
        }), !r && !o && (C(), window.removeEventListener("click", h));
      }
    };
    return {
      handleWindowResize: u,
      changeCountryLink: L,
      dontChangeCountryLink: C,
      outsidePromptClick: h,
      setRedirectCountryInCookie: M,
      setRedirectUrlInCookie: O,
      newCountryName: () => "countries." + c(i, m()).RedirectToCountryName,
      handleDoNotChange: p,
      t: k,
      areTranslationsLoaded: S,
      isVisible: n
    };
  }
});
export {
  ae as default
};
//# sourceMappingURL=index2.js.map
